import { render, staticRenderFns } from "./RegisterPemberianAmanat.vue?vue&type=template&id=823a8b18&scoped=true&"
import script from "./RegisterPemberianAmanat.vue?vue&type=script&lang=js&"
export * from "./RegisterPemberianAmanat.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPemberianAmanat.vue?vue&type=style&index=0&id=823a8b18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "823a8b18",
  null
  
)

export default component.exports